import * as React from 'react';

function InPlay(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.464 2.04l.073.034a.77.77 0 01.484.727c0 .38-.274.645-.563.742.039.143.06.306.06.487 4.266.503 7.582 4.098 7.582 8.495 0 4.712-3.819 8.55-8.55 8.55-4.731 0-8.55-3.838-8.55-8.55 0-4.36 3.316-7.992 7.544-8.495 0-.186.024-.352.066-.498-.283-.108-.532-.376-.532-.731 0-.503.429-.801.801-.801h.69c.68 0 .796 0 .895.04zM4.676 12.525c0 3.93 3.41 6.91 6.874 6.91 3.558 0 6.892-3.39 6.892-6.91 0-3.633-3.26-6.893-6.892-6.893-3.595 0-6.874 2.962-6.874 6.893zm7.116-.038L9.054 7.775a.494.494 0 00-.429-.261.617.617 0 00-.279.074.494.494 0 00-.26.429.59.59 0 00.074.298l2.7 4.694c.113.168.299.26.466.26a.428.428 0 00.261-.074.493.493 0 00.28-.466.41.41 0 00-.075-.242z"
        fill="currentColor"
      />
    </svg>
  );
}

export default InPlay;
